import { Splide } from '@splidejs/splide';
import { Video } from '@splidejs/splide-extension-video';

// Your main app
class TongkolspaceApp {
  constructor() {
    this.init();
  }

  init() {
    console.log('🚀 Tongkolspace App Initialized');
    this.initSliders();
    this.initAnchor();
    this.initShowHide();
    this.initMobileMenu();
    this.initNestedScroll();
  }

  initSliders() {

    // =============================
    // CONTENT SLIDE
    // =============================
    const contentSlideEl = document.querySelector('#content-slide');

    if (contentSlideEl) {
      this.splideMain = new Splide(contentSlideEl, {
        perPage: 1,
        direction: 'ttb',
        height: '100dvh',
        keyboard: 'global',
        wheel: true,
        wheelSleep: 300,
        releaseWheel: true,
        paginationDirection: 'ttb',
        updateHash: true,
        touchAngle: 45,
        drag: true,
        snap: true,
        waitForTransition: true,
        speed: 650,
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        video: {
          autoplay: true,
          mute: true,
          controls: false,
          loop: true,
        },
      }).mount({ Video });

      const initialHash = window.location.hash;
      if (initialHash) {
        const slides = this.splideMain.Components.Elements.slides;
        slides.forEach((slide, index) => {
          const slideHash = slide.getAttribute('data-splide-hash');
          if (slideHash && initialHash === `#${slideHash}`) {
            this.splideMain.go(index);
          }
        });
      }

      this.splideMain.on('move', (newIndex) => {
        const slides = this.splideMain.Components.Elements.slides;
        const slide = slides[newIndex];
        const hash = slide ? slide.getAttribute('data-splide-hash') : null;

        if (hash && window.location.hash !== `#${hash}`) {
          window.location.hash = hash;
        }

        this.setActiveSidebarLink();
      });
    }

    // =============================
    // MAIN + THUMBNAIL
    // =============================
    const mainEl = document.querySelector('#main-carousel');
    const thumbEl = document.querySelector('#thumbnail-carousel');

    if (mainEl && thumbEl) {
      const main = new Splide(mainEl, {
        perPage: 1,
        perMove: 1,
        type: 'fade',
        rewind: true,
        pagination: false,
        arrows: true,
        drag: false,
        autoplay: false,
        video: {
          autoplay: true,
          mute: true,
          controls: false, // 👈 ini yang penting
          loop: true,   // 👈 ini bikin video repeat terus
        },
      });

      const thumbnails = new Splide(thumbEl, {
        autoWidth: true,
        pagination: false,
        isNavigation: true,
        cover: true,
        breakpoints: {
          640: {
            perPage: 1,
            focus  : 'center',
          },
        },
      });

      main.sync(thumbnails);
      main.mount({ Video });
      thumbnails.mount();
    }


    // =============================
    // EVENT
    // =============================
    const eventEl = document.querySelector('#event-carousel');
    if (eventEl) {
      new Splide(eventEl, {
        perPage: 1,
        pagination: true,
        isNavigation: true,
      }).mount();
    }


    // =============================
    // CHALLENGE
    // =============================
    const challengeEl = document.querySelector('#challenge-carousel');
    if (challengeEl) {
      new Splide(challengeEl, {
        perPage: 1,
        type: 'loop',
        rewind: true,
        pagination: true,
        isNavigation: true,
      }).mount();
    }


    // =============================
    // GALLERY
    // =============================
    const galleryEl = document.querySelector('#gallery-carousel');
    if (galleryEl) {
      new Splide(galleryEl, {
        perPage: 1,
        // rewind: true,
        pagination: true,
        isNavigation: true,
      }).mount();
    }


    // =============================
    // GALLERY
    // =============================
    const joinEl = document.querySelector('#join-carousel');
    if (joinEl) {
      new Splide(joinEl, {
        perPage: 1,
        pagination: true,
        isNavigation: true,
        drag: true,
      }).mount();
    }

    // =============================
    // CONTENT SLIDE
    // =============================
    const contentMabar = document.querySelector('#mabar');



    if (contentMabar) {

      const splide = new Splide(contentMabar, {
        autoWidth: true,
        rewind: true,
        pagination: true,
        isNavigation: true,
      }).mount();

      const thumb = document.querySelector('.scrollbar__thumb');
      const track = document.querySelector('.scrollbar');
      const list = splide.Components.Elements.list;

      function updateThumbSize() {
        const visibleRatio = splide.root.offsetWidth / list.scrollWidth;
        const thumbWidth = track.offsetWidth * visibleRatio;

        thumb.style.width = thumbWidth + 'px';

        // 🔥 Hide scrollbar kalau tidak perlu scroll
        if (visibleRatio >= 1) {
          track.style.display = 'none';
        } else {
          track.style.display = 'block';
        }
      }

      function animate() {
        const maxScroll = list.scrollWidth - splide.root.offsetWidth;
        const current = Math.abs(splide.Components.Move.getPosition());
        const ratio = current / maxScroll;

        const maxTranslate = track.offsetWidth - thumb.offsetWidth;
        const translate = ratio * maxTranslate;

        thumb.style.transform = `translateX(${translate}px)`;

        requestAnimationFrame(animate);
      }

      splide.on('mounted resized', updateThumbSize);

      updateThumbSize();
      animate();

    }


    // if (contentMabar) {
    //   const splide = new Splide(contentMabar, {
    //     autoWidth: true,
    //     rewind: true,
    //     pagination: true,
    //     isNavigation: true,
    //   });

    //   const bar = splide.root.querySelector('.my-slider-progress-bar');

    //   splide.on('mounted move', function () {
    //     const end = splide.Components.Controller.getEnd() + 1;
    //     const rate = Math.min((splide.index + 1) / end, 1);

    //     if (bar) {
    //       bar.style.width = String(100 * rate) + '%';
    //     }
    //   });

    //   splide.mount();
    // }

    // const contentMabar = document.querySelector('#mabar');
    // if (contentMabar) {
    //   var bar = splide.root.querySelector('.my-carousel-progress-bar');
    //   new Splide(contentMabar, {
    //     autoWidth: true,
    //     rewind: true,
    //     pagination: true,
    //     isNavigation: true,
    //   }.on('mounted move', function () {
    //     var end = splide.Components.Controller.getEnd() + 1;
    //     var rate = Math.min((splide.index + 1) / end, 1);
    //     bar.style.width = String(100 * rate) + '%';
    //   }).mount();
    // }



  }

  initNestedScroll() {
    const scrollableSelectors = '.card-content__description, .card-challenge__content';
    const EDGE_GUARD_MS = 650;
    let edgeGuardUntil = 0;

    const hasScrollableParent = (target) => target.closest(scrollableSelectors);
    const smoothState = new WeakMap();

    const enqueueSmoothScroll = (el, deltaY) => {
      let state = smoothState.get(el);

      if (!state) {
        state = { velocity: 0, rafId: null };
        smoothState.set(el, state);
      }

      state.velocity += deltaY * 0.35;

      if (state.rafId) return;

      const tick = () => {
        const currentTop = el.scrollTop;
        el.scrollTop = currentTop + state.velocity;
        const moved = el.scrollTop !== currentTop;

        state.velocity *= 0.82;

        if (Math.abs(state.velocity) < 0.2 || !moved) {
          state.velocity = 0;
          state.rafId = null;
          return;
        }

        state.rafId = requestAnimationFrame(tick);
      };

      state.rafId = requestAnimationFrame(tick);
    };

    const canMoveByWheel = (el, deltaY) => {
      if (!el || el.scrollHeight <= el.clientHeight) return false;

      const atTop = el.scrollTop <= 0;
      const atBottom = Math.ceil(el.scrollTop + el.clientHeight) >= el.scrollHeight;

      if (deltaY < 0 && atTop) return false;
      if (deltaY > 0 && atBottom) return false;

      return true;
    };

    const scrollByWheel = (el, deltaY) => {
      if (!canMoveByWheel(el, deltaY)) return false;
      enqueueSmoothScroll(el, deltaY);
      return true;
    };

    const isAtEdge = (el, deltaY) => {
      const atTop = el.scrollTop <= 0;
      const atBottom = Math.ceil(el.scrollTop + el.clientHeight) >= el.scrollHeight;

      return (deltaY < 0 && atTop) || (deltaY > 0 && atBottom);
    };

    const setMainWheel = (enabled) => {
      if (!this.splideMain) return;
      this.splideMain.options = { wheel: enabled };
    };

    const setMainDrag = (enabled) => {
      if (!this.splideMain) return;
      this.splideMain.options = { drag: enabled };
    };

    const setMainInteractions = (enabled) => {
      setMainWheel(enabled);
      setMainDrag(enabled);
    };

    // Capture wheel early so Splide main slider does not steal it from inner article areas.
    document.addEventListener(
      'wheel',
      (event) => {
        const scrollable = hasScrollableParent(event.target);
        if (!scrollable) return;

        const now = Date.now();
        const moved = scrollByWheel(scrollable, event.deltaY);

        // Always keep wheel focus in the article area while cursor is inside it.
        event.preventDefault();
        event.stopPropagation();

        if (moved) {
          setMainInteractions(false);
          edgeGuardUntil = now + EDGE_GUARD_MS;
          return;
        }

        if (isAtEdge(scrollable, event.deltaY)) {
          // Keep consuming wheel for a short delay at top/bottom so it doesn't jump slides instantly.
          if (now < edgeGuardUntil) {
            setMainInteractions(false);
            return;
          }
          setMainInteractions(true);
          return;
        }

        setMainInteractions(false);
      },
      { passive: false, capture: true }
    );

    const supportsHoverPointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    document.querySelectorAll(scrollableSelectors).forEach((el) => {
      let isPointerDown = false;
      let startY = 0;
      let startScrollTop = 0;

      const syncScrollableState = () => {
        const canScroll = el.scrollHeight > el.clientHeight + 1;
        el.style.overflowY = canScroll ? 'scroll' : 'hidden';
      };

      syncScrollableState();

      el.addEventListener('mouseenter', () => {
        if (!supportsHoverPointer) return;
        syncScrollableState();
        setMainInteractions(false);
        edgeGuardUntil = Date.now() + EDGE_GUARD_MS;
      });

      el.addEventListener('mouseleave', () => {
        if (!supportsHoverPointer) return;
        if (!isPointerDown) {
          setMainInteractions(true);
        }
      });

      el.addEventListener('pointerdown', (event) => {
        syncScrollableState();
        event.preventDefault();
        event.stopPropagation();

        isPointerDown = true;
        startY = event.clientY;
        startScrollTop = el.scrollTop;
        setMainInteractions(false);
        edgeGuardUntil = Date.now() + EDGE_GUARD_MS;

        el.setPointerCapture(event.pointerId);
        el.style.cursor = 'grabbing';
        el.style.userSelect = 'none';
      }, { capture: true });

      el.addEventListener('pointermove', (event) => {
        if (!isPointerDown) return;

        event.preventDefault();
        event.stopPropagation();

        const deltaY = event.clientY - startY;
        el.scrollTop = startScrollTop - deltaY;
      }, { capture: true });

      const endDrag = (event) => {
        if (!isPointerDown) return;

        isPointerDown = false;
        edgeGuardUntil = Date.now() + EDGE_GUARD_MS;

        if (event && typeof event.pointerId === 'number' && el.hasPointerCapture(event.pointerId)) {
          el.releasePointerCapture(event.pointerId);
        }

        el.style.cursor = '';
        el.style.userSelect = '';
        if (!supportsHoverPointer || !el.matches(':hover')) {
          setMainInteractions(true);
        }
      };

      el.addEventListener('pointerup', endDrag);
      el.addEventListener('pointercancel', endDrag);

      const observer = new ResizeObserver(syncScrollableState);
      observer.observe(el);
      if (el.firstElementChild) {
        observer.observe(el.firstElementChild);
      }

      window.addEventListener('resize', syncScrollableState);
    });
  }

  // initAnchor() {
  //   const links = document.querySelectorAll(".splide-sidebar a");

  //   function setActiveLink() {
  //     // const currentHash = window.location.hash || "#section-1";
  //     const currentHash = window.location.hash;

  //     links.forEach(link => {
  //       link.classList.toggle(
  //         "is-active-sidebar",
  //         link.getAttribute("href") === currentHash
  //       );
  //     });
  //   }

  //   links.forEach(link => {
  //     link.addEventListener("click", function () {
  //       setTimeout(setActiveLink, 0);
  //     });
  //   });

  //   setActiveLink();
  //   window.addEventListener("hashchange", setActiveLink);
  // }

  setActiveSidebarLink() {
    const links = document.querySelectorAll(".splide-sidebar a");
    const currentHash = window.location.hash || "#section-1";

    links.forEach(link => {
      link.classList.toggle(
        "is-active-sidebar",
        link.getAttribute("href") === currentHash
      );
    });
  }

  initAnchor() {
    const links = document.querySelectorAll(".splide-sidebar a");

    links.forEach(link => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const hash = link.getAttribute("href");
        if (!hash) return;

        // Update URL hash first
        if (window.location.hash !== hash) {
          window.location.hash = hash.replace('#', '');
        }

        // Navigate to slide after URL updated
        if (this.splideMain) {
          const slides = this.splideMain.Components.Elements.slides;
          let targetIndex = -1;

          slides.forEach((slide, index) => {
            const slideHash = slide.getAttribute("data-splide-hash");
            if (slideHash && hash === `#${slideHash}`) {
              targetIndex = index;
            }
          });

          if (targetIndex !== -1) {
            this.splideMain.go(targetIndex);
          }
        } else {
          this.setActiveSidebarLink();
        }
      });
    });

    this.setActiveSidebarLink();
    window.addEventListener("hashchange", () => this.setActiveSidebarLink());
  }


  initShowHide() {
    const triggers = document.querySelectorAll('.leaderboard__categorys li');

    if (!triggers.length) return;

    const activate = (trigger) => {
      const targetSelector = trigger.dataset.showTrigger;
      const target = document.querySelector(targetSelector);

      // reset semua trigger & target
      triggers.forEach(item => item.classList.remove('show'));
      document.querySelectorAll('.leaderboard__article')
        .forEach(article => article.classList.remove('show'));

      // aktifkan yang dipilih
      trigger.classList.add('show');
      if (target) target.classList.add('show');
    };

    // event click
    triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        activate(trigger);
      });
    });

    // default active = item pertama
    activate(triggers[0]);
  }

  // initShowHide(){
  //   aku punya html ini
  //   <ul class="leaderboard__categorys">
  //       <li data-show-trigger="#pemenang">Pemenang</li>
  //       <li data-show-trigger="leaderboard">Leaderboard</li>
  //   </ul>

  //   <div class="leaderboard__article" id="pemenang">
  //   </div>
  //   <div class="leaderboard__article" id="leaderboard">
  //   </div>

  //   bisakah buatkan jika click data-show-trigger="#pemenang" maka data-show-trigger="#pemenang" dan #pemenang akan ada tambahan class '.show'
  //   dan default ada class active di data-show-trigger pertama
  // }

  initMobileMenu() {
    const menuToggle = document.querySelector('.menu-toggle');
    const sidebar = document.querySelector('.splide-sidebar');
    const footer = document.querySelector('.footerBasic');

    if (!menuToggle || !sidebar) return;

    // Handle footer movement for mobile
    const handleFooter = () => {
      const isMobile = window.innerWidth <= 992;
      let mobileFooter = sidebar.querySelector('.footerBasic--mobile');

      if (isMobile && !mobileFooter && footer) {
        // Clone footer into sidebar on mobile
        const footerClone = footer.cloneNode(true);
        footerClone.classList.add('footerBasic--mobile');
        sidebar.appendChild(footerClone);
        // Hide original footer
        footer.style.display = 'none';
      } else if (!isMobile && mobileFooter) {
        // Remove cloned footer on desktop
        mobileFooter.remove();
        // Show original footer
        if (footer) footer.style.display = '';
      }
    };

    // Handle footer in section-7 slide
    const handleFooterInSlide = () => {
      const isMobile = window.innerWidth <= 992;
      const contentSlide = document.querySelector('#content-slide');

      if (!contentSlide || !footer) return;

      // Find slide with data-splide-hash="section-7"
      const section7Slide = contentSlide.querySelector('.splide__slide[data-splide-hash="section-7"]');

      if (!section7Slide) return;

      // Check if footer already exists in section-7 slide
      let slideFooter = section7Slide.querySelector('.footerBasic--slide');

      if (isMobile && !slideFooter) {
        // Clone footer into section-7 slide
        const footerClone = footer.cloneNode(true);
        footerClone.classList.add('footerBasic--slide');
        footerClone.classList.add('footerBasic--mobile-slide');
        section7Slide.appendChild(footerClone);
      } else if (!isMobile && slideFooter) {
        // Remove cloned footer on desktop
        slideFooter.remove();
      }
    };

    // Initial check
    handleFooter();
    handleFooterInSlide();

    // Handle resize
    window.addEventListener('resize', () => {
      handleFooter();
      handleFooterInSlide();
    });

    const toggleMenu = (show) => {
      const isOpen = show !== undefined ? show : !sidebar.classList.contains('is-open');

      sidebar.classList.toggle('is-open', isOpen);
      menuToggle.classList.toggle('is-active', isOpen);
      menuToggle.setAttribute('aria-expanded', isOpen.toString());

      // Prevent body scroll when menu is open
      document.body.style.overflow = isOpen ? 'hidden' : '';
    };

    // Toggle button click
    menuToggle.addEventListener('click', () => toggleMenu());

    // Close when clicking sidebar links
    sidebar.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        // Small delay to allow navigation to work
        setTimeout(() => toggleMenu(false), 100);
      });
    });

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && sidebar.classList.contains('is-open')) {
        toggleMenu(false);
      }
    });

    // Close on resize to desktop
    window.addEventListener('resize', () => {
      if (window.innerWidth > 992 && sidebar.classList.contains('is-open')) {
        toggleMenu(false);
      }
    });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new TongkolspaceApp();
});

// Export for global access if needed
window.TongkolspaceApp = TongkolspaceApp;
